document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll
  const scrollLinks = document.querySelectorAll('.scrolling');
  scrollLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetID = this.getAttribute('href');
      const targetElement = document.querySelector(targetID);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop - 60; // Ajusta si tienes header fijo
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });

  // // Menu toggle
  // const menuOpen = document.querySelector('.menu-open');
  // const menuClose = document.querySelector('.menu-close');
  // const overlay = document.querySelector('.header-overlay');
  // const menu = document.querySelector('.header-main .section-header .menu') || document.querySelector('.main-nav');

  // const openMenu = () => {
  //   if (menuOpen) menuOpen.style.display = 'none';
  //   if (menuClose) menuClose.style.display = 'block';
  //   if (overlay) overlay.style.display = 'block';
  //   if (menu) menu.classList.add('show');
  // };

  // const closeMenu = () => {
  //   if (menuOpen) menuOpen.style.display = 'block';
  //   if (menuClose) menuClose.style.display = 'none';
  //   if (overlay) overlay.style.display = 'none';
  //   if (menu) menu.classList.remove('show');
  // };

  // if (menuOpen) menuOpen.addEventListener('click', openMenu);
  // if (menuClose) menuClose.addEventListener('click', closeMenu);
  // if (overlay) overlay.addEventListener('click', closeMenu);
  // scrollLinks.forEach(link => link.addEventListener('click', closeMenu));

    // Menu toggle
    const menuOpen = document.querySelector('.menu-open');
    const menuClose = document.querySelector('.menu-close');
    const overlay = document.querySelector('.header-overlay');
    const menu = document.querySelector('.header-main .section-header .menu') || document.querySelector('.main-nav');
  
    const openMenu = () => {
      if (menuOpen) menuOpen.style.display = 'none';
      if (menuClose) menuClose.style.display = 'block';
      if (overlay) overlay.style.display = 'block';
      if (menu) menu.classList.add('show');
    };
  
    const closeMenu = () => {
      if (menuOpen) menuOpen.style.display = 'block';
      if (menuClose) menuClose.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      if (menu) menu.classList.remove('show');
    };
  
    if (menuOpen) menuOpen.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    scrollLinks.forEach(link => link.addEventListener('click', closeMenu));

  // Scroll Spy con IntersectionObserver
  const sections = document.querySelectorAll('.section-scroll');

  const removeAllActive = () => {
    scrollLinks.forEach(link => link.classList.remove('active'));
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -60% 0px', // dispara cuando el 40% superior entra en vista
    threshold: 0.25
  };

  const observer = new IntersectionObserver((entries) => {
    // Si estás muy arriba, limpia todos los active
    if (window.scrollY < 100) {
      removeAllActive();
      return;
    }

    entries.forEach(entry => {
      const id = entry.target.getAttribute('id');
      const link = document.querySelector(`.scrolling[href="#${id}"]`);

      if (entry.isIntersecting) {
        removeAllActive();
        if (link) link.classList.add('active');
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    if (section.id) observer.observe(section);
  });

  // Extra: escucha scroll para desactivar si scroll < 100
  window.addEventListener('scroll', () => {
    if (window.scrollY < 100) {
      removeAllActive();
    }
  });

  /*const sScrollLinks = document.querySelectorAll('.onepage-scroll');
  sScrollLinks.forEach(sLink => {
    sLink.addEventListener('click', function (e) {
      e.preventDefault();
      const sTargetID = this.getAttribute('href');
      const sTargetElement = document.querySelector(sTargetID);

      if (sTargetElement) {
        const sOffsetTop = sTargetElement.offsetTop - 60;
        window.scrollTo({
          top: sOffsetTop,
          behavior: 'smooth'
        });
      }
    });
  });*/
});


$(document).ready(function() {
  $('.onepage-scroll').on('click', function(e) {
    e.preventDefault();
    const sTargetID = $(this).attr('href');
    const $targetElement = $(sTargetID);

    if ($targetElement.length) {
      const sOffsetTop = $targetElement.offset().top - 60;

      window.scrollTo({
        top: sOffsetTop,
        behavior: 'smooth'
      });
    } else {
      console.warn('Elemento no encontrado:', sTargetID);
    }
  });
});





